<template lang="pug">
router-link.basketLink(v-if="!activeModal" :to="{name: 'Basket'}")
  .text Открыть корзину
  .icon
    ui-svg-icon(
      name="basket"
      :size="16"
      :originalColors="false"
    )
  .amount ({{ itemsCount }})
  .price {{ totalPrice }} ₽
</template>

<script>
import { computed, inject } from 'vue'
export default {
  setup () {
    const store = inject('store')
    const itemsCount = computed(() => store.basket.data?.itemsCount)
    const totalPrice = computed(() => store.basket.data?.totalNewPrice || store.basket.data?.totalPrice)
    const activeModal = computed(() => store.modalQueue.activeModal)
    return { totalPrice, itemsCount, activeModal }
  }
}
</script>

<style lang="sass" scoped>
.basketLink
  border-radius: 10px 10px 0px 0px
  padding: 10px 16px
  background: $lectaBlue
  position: fixed
  bottom: 0
  right: calc((100vw - (100vw - 100%) - #{$appMaxWidth - 18*$u}) / 2)
  display: flex
  gap: 6px
  align-items: center
  color: $cWhite
  max-width: 270px
  width: 100%
  @include font('t14-regular')
  @media (max-width: $appMaxWidth)
    right: 9*$u
  @media (max-width: $padWidth)
    right: 5*$u
  &.stop
    position: absolute
    bottom: 100%
  > .price
    margin-left: auto
</style>
